import {
    ApiHandler,
    createHandlerChainRunner,
    HasOnError,
    HasOnSuccess,
    markSkipOnCompleteIfOnErrorIsSet,
    markSkipOnCompleteIfOnSuccessIsSet,
} from "@insite/client-framework/HandlerCreator";
import { ServiceResult } from "@insite/client-framework/Services/ApiService";
import { BaseModel } from "@insite/client-framework/Types/ApiModels";
import { getOrderPdf } from "@wausauCustomBlueprint/Services/OrderPdfService";

export interface OrderPdfParameter {
    orderNumber: string;
    onSuccess?: () => void;
    onError?: (error: string) => void;
}

type HandlerType = ApiHandler<OrderPdfParameter, ServiceResult<any>>;

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = props.parameter;
};

export const RequestDataFromApi: HandlerType = async props => {
    await getOrderPdf(props.apiParameter);
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    markSkipOnCompleteIfOnSuccessIsSet(props);
    props.parameter.onSuccess?.();
};

export const ExecuteOnErrorCallback: HandlerType = props => {
    markSkipOnCompleteIfOnErrorIsSet(props);
};

export const chain = [PopulateApiParameter, RequestDataFromApi, ExecuteOnSuccessCallback, ExecuteOnErrorCallback];

const orderPdfHandler = createHandlerChainRunner(chain, "OrderPdfHandler");
export default orderPdfHandler;
